import { render, staticRenderFns } from "./EtaChartTipoDado.vue?vue&type=template&id=70aa718b&scoped=true&"
import script from "./EtaChartTipoDado.vue?vue&type=script&lang=js&"
export * from "./EtaChartTipoDado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aa718b",
  null
  
)

export default component.exports